// 数字三位逗号显示
export function toThousands (num) {
  const result = []
  let counter = 0
  num = (num || 0).toString().split('')
  for (var i = num.length - 1; i >= 0; i--) {
    counter++
    result.unshift(num[i])
    if (!(counter % 3) && i !== 0) {
      result.unshift(',')
    }
  }
  return result.join('')
}

// 格式化时间
export function formatDate (date, fmt = 'yyyy-MM-dd hh:mm:ss') {
  // let fmt = 'yyyy-MM-dd hh:mm:ss' // 到时分秒
  // let fmt = 'yyyy-MM-dd' // 只有年月日
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, date.getFullYear())
  }
  for (const k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, o[k].toString().length === 1 ? '0' + o[k] : o[k])
    }
  }
  return fmt
}

/**
 * 获取近多少天的date
 * @param num: 天数
 */
export function getDateForNum (num) {
  const start = new Date()
  start.setTime(start.getTime() - 3600 * 1000 * 24 * num)
  start.setHours(0)
  start.setMinutes(0)
  start.setSeconds(0)
  const end = new Date()
  end.setHours(0)
  end.setMinutes(0)
  end.setSeconds(0)
  return {
    start,
    end
  }
}

// 获取localStorage或者cookie的值
export function getCookie (name) {
  if (document.cookie.length > 0) {
    var start = document.cookie.indexOf(name + '=')
    if (start !== -1) {
      start = start + name.length + 1
      var end = document.cookie.indexOf(';', start)
      if (end === -1) end = document.cookie.length
      return unescape(document.cookie.substring(start, end))
    }
  }
  return undefined
}
export function getLocalStorage (name) {
  return window.localStorage.getItem(name)
}
export default { getLocalStorage, getCookie }
